/* eslint-disable no-unused-vars */
import babelpolyfill from 'babel-polyfill';
/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Framework7 from 'framework7/framework7.esm.bundle';
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle';

import 'framework7/css/framework7.css';
import 'font-awesome/css/font-awesome.min.css';
import '@/style/icons.css';
import '@/style/app.scss';

import store from './store';
import App from './app';

Framework7.use(Framework7Vue);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<app/>',
  components: {
    app: App,
  },
  store,
});



// WEBPACK FOOTER //
// ./src/main.js